export function normalizeCalendlyUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  try {
    const url = new URL(raw);
    const host = url.hostname.toLowerCase().replace(/^www\./, "");
    if (
      url.protocol !== "https:" ||
      !(host === "calendly.com" || host.endsWith(".calendly.com")) ||
      !url.pathname ||
      url.pathname === "/"
    ) {
      return "";
    }
    url.hash = "";
    return url.toString();
  } catch {
    return "";
  }
}

export function isValidCalendlyUrl(value) {
  return Boolean(normalizeCalendlyUrl(value));
}
